function toggleEventDetails(eventId) {
  const content = document.getElementById('details-' + eventId);
  if (content) {
    content.classList.toggle('active');
    
    // Update the button text
    const btn = document.getElementById('btn-' + eventId);
    if (btn) {
      if (content.classList.contains('active')) {
        btn.textContent = 'Hide Details';
      } else {
        btn.textContent = 'Show Details (Prizes)';
      }
    }
  }
}